module.exports = __webpack_public_path__ + "img/logo.e276f65c.png";